// Omnix/client/ui/TemplateManager.js
import { ComponentBase } from "../core/ComponentBase.js";

export class TemplateManager extends ComponentBase {
    constructor(config) {
        super(config);
        this.dataCrud = null;
    }

    async initialize() {
        this.dataCrud = await this.createManagedComponent("DataCrud", null, {
            instanceId: `${this.config.instanceId}-crud`,
            rpcClass: "TemplateRpc",
            schemaPath: "collections/omniTemplates",
            title: "Message Templates",
            viewConfig: {
                mode: 'grid',
                fields: [
                    { name: 'name', label: 'Template Name' },
                    { name: 'channelType', label: 'Channel', render: (val) => `<span class="badge bg-info text-dark">${val}</span>` },
                    { name: 'subject', label: 'Subject' },
                    { name: 'tags', label: 'Tags', render: (tags) => (tags || []).map(t => `<span class="badge bg-secondary me-1">${t}</span>`).join('') }
                ],
                toolbar: { create: { enabled: true, label: "New Template" } }
            },
            formConfig: {
                fields: {
                    name: { type: 'text', label: 'Template Name', required: true },
                    channelType: {
                        type: 'select', label: 'Channel Type', required: true,
                        options: [
                            { value: 'email', label: 'Email' },
                            { value: 'message', label: 'Message' }
                        ]
                    },

                    tags: {
                        type: 'TagInput',
                        component: 'TagInput',
                        label: 'Tags',
                        creatable: true,
                        optionsSourceRpc: { method: 'TemplateRpc.getTemplateTags' },
                        placeholder: 'Add tags...'
                    },
                    subject: {
                        type: 'text', label: 'Subject',
                        visibleWhen: (data) => data.channelType === 'email'
                    },
                    body: {
                        type: 'TemplateEditorField',
                        component: 'TemplateEditorField',
                        label: 'Template Body',
                        required: true
                    }
                }
            },
            dataConfig: { autoLoad: false }
        });
        await super.initialize();
    }

    async initAfterLogin() {
        if (this.dataCrud) {
            this.dataCrud.refreshData();
        }
    }

    async render() {
        return await this.dataCrud.render();
    }

    destroy() {
        this.dataCrud?.destroy();
        super.destroy();
    }
}